module.exports = __webpack_public_path__ + "static/media/Services_CMYK.a7737066.jpg";